new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: ''
    },
    methods: {
        // Máscara/validação do formulário "avise-me quando chegar".
        // Os eventos são delegados no document porque o formulário só é injetado
        // quando o cliente escolhe uma variação sem estoque, e é re-renderizado a
        // cada troca de tamanho: listeners presos no elemento se perderiam.
        initNotifyNotAvailableForm() {
            const FORM = '#form_notify_not_available_product';
            const EMAIL = '#email_notify';
            const PHONE = '#celular_notify';

            if (document.body.dataset.notifyMaskBound) return;
            document.body.dataset.notifyMaskBound = '1';

            const emailPattern = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/;

            const validDDDs = [
                11, 12, 13, 14, 15, 16, 17, 18, 19,
                21, 22, 24, 27, 28,
                31, 32, 33, 34, 35, 37, 38,
                41, 42, 43, 44, 45, 46, 47, 48, 49,
                51, 53, 54, 55,
                61, 62, 63, 64, 65, 66, 67, 68, 69,
                71, 73, 74, 75, 77, 79,
                81, 82, 83, 84, 85, 86, 87, 88, 89,
                91, 92, 93, 94, 95, 96, 97, 98, 99
            ];

            // o cliente digita/cola do jeito que quiser: 16999999999, 16 99999-9999,
            // +55 (16) 99999-9999... aqui sobra só o DDD + número
            const phoneDigits = (value) => {
                let digits = (value || '').replace(/\D/g, '');
                if (digits.length > 11 && digits.startsWith('55')) {
                    digits = digits.slice(2);
                }
                return digits.slice(0, 11);
            };

            const phoneMask = (value) => {
                const digits = phoneDigits(value);
                if (!digits.length) return '';
                if (digits.length <= 2) return `(${digits}`;
                if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
                if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
                return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
            };

            const phoneError = (digits) => {
                if (!digits.length) return '';
                if (digits.length < 11) return 'Digite o DDD e os 9 dígitos do celular. Ex: (16) 99999-9999';
                if (!validDDDs.includes(Number(digits.slice(0, 2)))) return 'DDD inválido. Confira os 2 primeiros dígitos.';
                if (digits[2] !== '9') return 'Celular inválido: o número deve começar com 9 depois do DDD.';
                if (/^(\d)\1+$/.test(digits.slice(2))) return 'Digite um número de celular válido.';
                return '';
            };

            // campo vazio fica a cargo do required, para não duplicar a mensagem do navegador
            const validateEmail = (input) => {
                const value = input.value.trim();
                input.setCustomValidity(!value || emailPattern.test(value) ? '' : 'Digite um e-mail válido. Ex: nome@email.com');
            };

            const validatePhone = (input) => {
                input.setCustomValidity(phoneError(phoneDigits(input.value)));
            };

            const applyPhoneMask = (input) => {
                const masked = phoneMask(input.value);
                if (input.value !== masked) input.value = masked;
                validatePhone(input);
            };

            // só reage a campos que estejam realmente dentro do formulário de aviso
            const fieldIn = (event, selector) => {
                const target = event.target;
                if (!(target instanceof Element) || !target.matches(selector)) return null;
                return target.closest(FORM) ? target : null;
            };

            // trava letras e símbolos; separadores passam e são absorvidos pela
            // máscara, para quem digita "(16) 99999-9999" ou "16 99999 9999" na mão
            const allowedChar = /[\d()\-+.\s]/;

            document.addEventListener('beforeinput', (e) => {
                if (!fieldIn(e, PHONE)) return;
                const typing = e.inputType === 'insertText' || e.inputType === 'insertCompositionText';
                if (typing && e.data && !allowedChar.test(e.data)) {
                    e.preventDefault();
                }
            });

            document.addEventListener('keydown', (e) => {
                if (!fieldIn(e, PHONE)) return;
                if (e.key === 'Enter' || e.ctrlKey || e.metaKey || e.altKey) return;
                if (e.key.length === 1 && !allowedChar.test(e.key)) {
                    e.preventDefault();
                }
            });

            // input, change e focusout borbulham, então a delegação alcança os três
            ['input', 'change', 'focusout'].forEach(eventName => {
                document.addEventListener(eventName, (e) => {
                    const phone = fieldIn(e, PHONE);
                    if (phone) {
                        phone.classList.remove('is-invalid');
                        applyPhoneMask(phone);
                        return;
                    }
                    const email = fieldIn(e, EMAIL);
                    if (email) {
                        email.classList.remove('is-invalid');
                        validateEmail(email);
                    }
                });
            });

            // revalida antes do envio para cobrir preenchimento automático do navegador
            document.addEventListener('click', (e) => {
                const target = e.target;
                if (!(target instanceof Element) || target.type !== 'submit') return;
                const form = target.closest(FORM);
                if (!form) return;

                const email = form.querySelector(EMAIL);
                const phone = form.querySelector(PHONE);
                if (email) validateEmail(email);
                if (phone) applyPhoneMask(phone);
            }, true);

            // invalid não borbulha, por isso a fase de captura
            document.addEventListener('invalid', (e) => {
                const target = e.target;
                if (target instanceof Element && target.closest(FORM)) {
                    target.classList.add('is-invalid');
                }
            }, true);
        },
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            // Galeria com miniaturas (admin: Detalhe Produto → Exibição das fotos):
            // gallery-left / gallery-right / gallery-bottom usam o MESMO comportamento —
            // #product-photo vira um slick de 1 foto e as miniaturas (#photo-list) navegam
            // nele no hover e no clique, como no Mercado Livre. Só no desktop: no mobile
            // quem aparece é o .mobile-slider.
            const isThumbGallery = photoArea && ['gallery-left', 'gallery-right', 'gallery-bottom']
                .some(mode => photoArea.classList.contains(mode));

            if (photoThumbs && isThumbGallery && window.matchMedia('(min-width: 992px)').matches) {
                const $mainPhoto = $('#product-photo');
                const thumbItems = Array.from(document.querySelectorAll('#photo-list li'));

                // passando disso, a última miniatura visível vira "+N" e abre o zoom
                const MAX_THUMBS = 8;
                const hasMore = thumbItems.length > MAX_THUMBS;
                const lastVisible = hasMore ? MAX_THUMBS - 1 : thumbItems.length - 1;

                // foto além das miniaturas visíveis (chegou arrastando a principal) marca o "+N"
                function setActiveThumb(index) {
                    const target = Math.min(index, lastVisible);
                    thumbItems.forEach((li, i) => li.classList.toggle('active', i === target));
                }

                function openZoom(index) {
                    const slide = $mainPhoto.find('.slick-slide').eq(index).get(0);
                    const link = slide && slide.querySelector('[data-fancybox]');
                    if (link) link.click();
                }

                $mainPhoto.on('afterChange', function (event, slick, currentSlide) {
                    setActiveThumb(currentSlide);
                });

                $mainPhoto.slick({
                    arrows: false,
                    dots: false,
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipeToSlide: true,
                    touchThreshold: 100,
                    speed: 300,
                });

                thumbItems.forEach((item, index) => {
                    if (index > lastVisible) {
                        item.classList.add('is-hidden');
                        return;
                    }

                    if (hasMore && index === lastVisible) {
                        item.classList.add('has-more');
                        item.dataset.more = '+' + (thumbItems.length - lastVisible);
                        item.addEventListener('click', () => {
                            $mainPhoto.slick('slickGoTo', index);
                            openZoom(index);
                        });
                        return;
                    }

                    item.addEventListener('mouseenter', () => $mainPhoto.slick('slickGoTo', index));
                    item.addEventListener('click', () => $mainPhoto.slick('slickGoTo', index));
                });

                setActiveThumb(0);
            }

            // if(photoArea.classList.contains('default')) {
            //     if (window.matchMedia("(min-width: 992px)").matches) {
            //         let lastScrollTop = 0;

            //         function animeScroll() {
            //             const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //             const banner = document.querySelector('.product-detail__banner');
            //             const appHeader = document.getElementById('app_header');

            //             if (photoScroll) {
            //                 const infoArea = document.querySelector('.product-detail__header--infoArea');
            //                 const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
            //                 const containerHeight = $container.outerHeight();
            //                 const containerTop = $container.offset() ? $container.offset().top : 0;
            //                 const sidebarOuterHeight = $('.sidebar__inner').outerHeight();
            //                 const containerWidth = $container.width();
            //                 const totalHeight = containerHeight - sidebarOuterHeight; // deslocamento máximo relativo ao container
            //                 const pageTop = window.scrollY;

            //                 // Verifica se existe banner e calcula quando ele sai da tela
            //                 let bannerOffset = 0;
            //                 if (banner) {
            //                     const bannerRect = banner.getBoundingClientRect();
            //                     const bannerHeight = banner.offsetHeight;
            //                     bannerOffset = bannerHeight;
            //                 }

            //                 // Calcula a altura do header para o top na volta
            //                 let headerHeight = 0;
            //                 if (appHeader) {
            //                     headerHeight = appHeader.offsetHeight;
            //                 }

            //                 // Limites de scroll baseados no container e header
            //                 const safeTotalHeight = Math.max(0, totalHeight);
            //                 const startScroll = containerTop - headerHeight; // ponto para começar a fixar
            //                 const endScroll = containerTop + containerHeight - headerHeight - sidebarOuterHeight; // ponto para parar a fixação

            //                 if (pageTop <= startScroll) {
            //                     // Antes do container tocar o header: posição normal
            //                     $('.sidebar__inner').css({ position: 'relative' });
            //                     $('.sidebar__inner').css({ top: "0px" });
            //                     $('.sidebar__inner').css({ width: "100%" });
            //                     $('.sidebar__inner').css({ maxWidth: "100%" });
            //                 } else if (pageTop >= endScroll) {
            //                     // Depois do final do container: travado no rodapé do container
            //                     $('.sidebar__inner').css({ position: 'relative' });
            //                     $('.sidebar__inner').css({ top: safeTotalHeight + "px" });
            //                     $('.sidebar__inner').css({ width: "100%" });
            //                     $('.sidebar__inner').css({ maxWidth: "100%" });
            //                 } else {
            //                     // Dentro da faixa: fixo logo abaixo do header e com a largura do container
            //                     $('.sidebar__inner').css({ position: 'fixed' });
            //                     $('.sidebar__inner').css({ top: headerHeight + "px" });
            //                     if (containerWidth) {
            //                         $('.sidebar__inner').css({ width: containerWidth + "px" });
            //                         $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
            //                     }
            //                 }

            //                 lastScrollTop = pageTop;
            //             }
            //         }

            //         window.addEventListener('scroll', function () {
            //             if (screen.width > 991) {
            //                 const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //                 if (photoScroll) {
            //                     animeScroll();
            //                 }
            //             }
            //         });

            //         window.onresize = function () {
            //             const photoScroll = document.querySelector('.product-detail__header--photoArea');
            //             if (photoScroll) {
            //                 if ($('.sidebar__inner').css('position') === 'fixed') {
            //                     const infoArea = document.querySelector('.product-detail__header--infoArea');
            //                     const $container = infoArea ? $(infoArea) : $('.product-detail__header--photoArea');
            //                     const containerWidth = $container.width();
            //                     if (containerWidth) {
            //                         $('.sidebar__inner').css({ width: containerWidth + "px" });
            //                         $('.sidebar__inner').css({ maxWidth: containerWidth + "px" });
            //                     }
            //                 }
            //             }
            //         };
            //     }
            // }
            // Galeria com scroll: a coluna de fotos rola dentro do próprio quadro (altura no
            // CSS); a miniatura leva até a foto sem rolar a página inteira.
            if (photoArea && photoArea.classList.contains('gallery-scroll')) {
                const productPhoto = document.querySelector('#product-photo');
                const photos = productPhoto ? Array.from(productPhoto.children) : [];
                const miniThumbs = Array.from(document.querySelectorAll('.product-detail__header--photoArea-thumbs #photo-list li'));

                if (photos.length && miniThumbs.length) {
                    miniThumbs[0].classList.add('active');

                    miniThumbs.forEach((thumb, index) => {
                        thumb.addEventListener('click', () => {
                            const target = photos[index];
                            if (!target) return;

                            miniThumbs.forEach(li => li.classList.toggle('active', li === thumb));
                            productPhoto.scrollTo({
                                top: productPhoto.scrollTop + target.getBoundingClientRect().top - productPhoto.getBoundingClientRect().top,
                                behavior: 'smooth'
                            });
                        });
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            // Mantido só por compatibilidade: a lógica do botão flutuante agora
            // vive em initFixedBuy(), fora do Vue (ver final do arquivo).
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        }
    },
    mounted() {
        this.initNotifyNotAvailableForm();

        let description = document.querySelector('.description-nav');
        if (description) {
            let navTab = description.querySelectorAll('.nav-item');
            let navShow = description.querySelectorAll('.description-nav-content');
            navTab = Array.from(navTab);
            navShow = Array.from(navShow);

            if (navTab.length && navShow.length) {
                navTab[0].classList.add('active');
                navShow[0].classList.add('active');

                function toggleTab(index) {
                    const isActive = navTab[index].classList.contains('active');

                    // remove todas as classes active
                    navTab.forEach((content) => content.classList.remove('active'));
                    navShow.forEach((content) => content.classList.remove('active'));

                    // se não estava ativo, ativa
                    if (!isActive) {
                        navTab[index].classList.add('active');
                        navShow[index].classList.add('active');
                    }
                }

                navTab.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', () => {
                        toggleTab(index);
                    });
                });
            }
        }

        const groupSizeTitle = document.querySelector('.group-size .group-size-title');
        const productRadioVariation = document.querySelector('.product-radio-variation .label_attributes');
        if (groupSizeTitle && productRadioVariation) {
            groupSizeTitle.textContent = productRadioVariation.textContent;
        }

        waitForElementToExist('.price-cupom').then(element => {
            const priceCupom = document.querySelector('.price-cupom b');

            if (priceCupom) {
                const priceCupomValue = priceCupom.textContent;

                if (priceCupomValue) {
                    let newValue = priceCupomValue;

                    if (priceCupom) {
                        priceCupom.addEventListener("click", (e) => {
                            e.preventDefault();

                            navigator.clipboard.writeText(newValue).then(() => {
                                alert("Valor copiado: " + newValue);
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        this.clickThumbs();

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
})

/*
 * Botão de comprar flutuante (mobile).
 * Só aparece depois que o botão de comprar da página sai por completo da tela.
 * Fica fora do Vue de propósito: se algo quebrar no mounted(), o botão continua
 * funcionando em vez de travar visível.
 */
function initFixedBuy() {
    const buyButton = document.getElementById('buy-button');
    const fixedBuy = document.querySelector('.product-detail__fixed--buy');

    if (!buyButton || !fixedBuy) return;

    // Começa escondido; quem manda exibir é a checagem abaixo.
    fixedBuy.classList.remove('active');

    const setVisible = (visible) => {
        fixedBuy.classList.toggle('active', visible);
    };

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
            entries => entries.forEach(entry => setVisible(!entry.isIntersecting)),
            { threshold: 0 }
        );
        observer.observe(buyButton);
        return;
    }

    // Fallback para navegadores sem IntersectionObserver
    const check = () => {
        const rect = buyButton.getBoundingClientRect();
        const outOfView = rect.bottom <= 0 || rect.top >= window.innerHeight;
        setVisible(outOfView);
    };

    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
}

var PICKUP_NAME_RE = /retirada\s+na\s+loja/i;

function buildPickupLabel(rawName) {
    if (!PICKUP_NAME_RE.test(rawName)) return null;

    var local = (rawName.match(/\|([^|]+)\|/) || [])[1];
    if (!local) return null;

    var cidade = local.replace(/^\s*em\s+/i, '').trim();

    return cidade ? 'Retirada na loja - ' + cidade : 'Retirada na loja';
}

// A Frenet manda ServiceDescription e Carrier iguais em vários serviços
// (". Rodonaves - Rodonaves"), e o backend concatena os dois. Mantém só o serviço.
function buildDedupedLabel(rawName) {
    var parts = rawName.split(' - ');
    if (parts.length !== 2) return null;

    var servico = parts[0].trim();
    var carrier = parts[1].trim();
    // O prefixo "." é o nome da transportadora no admin, não faz parte do serviço
    var servicoLimpo = servico.replace(/^\.\s*/, '').trim();

    if (!servicoLimpo || servicoLimpo.toLowerCase() !== carrier.toLowerCase()) return null;

    return servico;
}

function buildShippingLabel(rawName) {
    return buildPickupLabel(rawName) || buildDedupedLabel(rawName);
}

function fixPickupLabels(tableBody) {
    tableBody.querySelectorAll('tr > td:first-child').forEach(function (cell) {
        var label = buildShippingLabel(cell.textContent);
        if (label) cell.textContent = label;
    });
}

function initPickupLabel() {
    var tableBody = document.getElementById('js_shipping_calculation_table_body');

    if (!tableBody || !('MutationObserver' in window)) return;

    new MutationObserver(function () {
        fixPickupLabels(tableBody);
    }).observe(tableBody, { childList: true });

    fixPickupLabels(tableBody);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        initFixedBuy();
        initPickupLabel();
    });
} else {
    initFixedBuy();
    initPickupLabel();
}

$(document).ready(function () {

    // Todos os widgets de variação (select, radio e cor/imagem) usam este prefixo de name
    var KIT_VARIATION_SELECTOR = '[name^="product_item_variation__product_detail_"]';

    function getKitVariationInputs(slide) {
        return Array.prototype.slice.call(slide.querySelectorAll(KIT_VARIATION_SELECTOR)).filter(function (input) {
            return input.tagName === 'SELECT' || input.type === 'radio';
        });
    }

    // Item do kit resolvido: não exige escolha ou o cliente já escolheu em todos os grupos de variação
    function isKitSlideReady(slide) {
        var itemKit = slide.querySelector('.js_product_item_kit');

        if (itemKit && itemKit.getAttribute('data-no-variations')) {
            return true;
        }

        var groups = {};

        getKitVariationInputs(slide).forEach(function (input) {
            var isSelected = input.tagName === 'SELECT' ? Boolean(input.value) : input.checked;
            groups[input.name] = Boolean(groups[input.name]) || isSelected;
        });

        return Object.keys(groups).every(function (name) {
            return groups[name];
        });
    }

    function setupKitCarousel(carousel) {
        // O carrossel do kit pode ser renderizado mais de uma vez na página (ex.: barra de compra fixa)
        var scope = carousel.closest('.product-detail__header--infoArea') || document;
        var nav = scope.querySelector('.carousel-kit-content');
        var slides = Array.prototype.slice.call(carousel.querySelectorAll('.splide__slide'));
        var addToCartButtons = Array.prototype.slice.call(scope.querySelectorAll('.js-btn__product_detail__add_to_cart'));

        // Só libera o botão comprar quando todos os itens do kit estiverem resolvidos
        function syncAddToCart() {
            var isKitReady = slides.every(isKitSlideReady);

            addToCartButtons.forEach(function (button) {
                button.classList.toggle('no-buy', !isKitReady);
            });

            return isKitReady;
        }

        // jQuery cobre tanto os eventos nativos quanto os disparados via $(el).trigger('change')
        // OBS: os handlers não podem retornar o resultado de syncAddToCart, senão o retorno false cancelaria o evento
        $(carousel).on('change', function () {
            syncAddToCart();
        });
        $(carousel).on('click', function () {
            window.setTimeout(syncAddToCart, 0);
        });

        // Sem a navegação renderizada não há como avançar no carrossel, então exibe os itens empilhados
        if (!nav) {
            carousel.classList.remove('splide');
            carousel.classList.add('carousel-kit--stacked');
            syncAddToCart();
            return;
        }

        var splide = new Splide(carousel, {
            type: "slide",
            height: 'auto', // Isso aqui ativa o adaptive height
            autoHeight: true,
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        var nextButton = nav.querySelector('.carousel-kit-next');
        var prevButton = nav.querySelector('.carousel-kit-prev');
        var message = nav.querySelector('.carousel-message');
        var countDisplay = nav.querySelector('.carousel-count');

        splide.on('mounted', function () {
            var totalSlides = splide.length;

            nextButton.setAttribute('data-end', totalSlides - 1);
            countDisplay.textContent = '1/' + totalSlides;
            syncAddToCart();
        });

        splide.mount();

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'data-actual') {
                    var actual = parseInt(nextButton.getAttribute('data-actual'));
                    var end = parseInt(nextButton.getAttribute('data-end'));

                    if (actual === end) {
                        nextButton.classList.add('no-click');
                    } else {
                        nextButton.classList.remove('no-click');
                    }
                }
            });
        });

        // Configurar o observer para monitorar mudanças no atributo data-actual
        observer.observe(nextButton, {
            attributes: true,
            attributeFilter: ['data-actual']
        });

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = carousel.querySelector('.splide__slide.is-active');

                if (!activeSlide || isKitSlideReady(activeSlide)) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
            syncAddToCart();
        });
    }

    Array.prototype.forEach.call(document.querySelectorAll('.carousel-kit'), setupKitCarousel);


    $("body").on("click", ".btn-group.btn-minus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        }

        if (qtd > 1) qtd--;
        qt_el.val(qtd);
    });

    $("body").on("click", ".btn-group.btn-plus", function (event) {
        var $this = $(this);
        var clt = $this.closest(".amount");
        var qt_el = clt.find(".product-detail__qtd--input");
        var qtd = parseInt(qt_el.val());
        if (isNaN(qtd)) {
            qtd = 1;
        } else {
            qtd++;
        }
        qt_el.val(qtd);
    });

    waitForElementToExist('#js_buy_together_api_layout_1_groups').then(element => {
        const ADD_CART_BTN_SELECTOR = '#js_buy_together_api_add_cart';
        const GROUP_SELECTOR = '#js_buy_together_api_group_0, #js_buy_together_api_group_1, #js_buy_together_api_group_2';

        // Rastreia quais grupos o usuário já selecionou tamanho (não depende do DOM)
        const selectedGroups = new Set();

        const getGroups = () => Array.from(document.querySelectorAll(GROUP_SELECTOR));

        // Garante please-select em grupos novos e atualiza o botão
        const syncUI = () => {
            const groups = getGroups();
            const addCartBtn = document.querySelector(ADD_CART_BTN_SELECTOR);
            if (!addCartBtn) return;

            groups.forEach(group => {
                if (!selectedGroups.has(group.id)) {
                    group.classList.add('please-select');
                }
            });

            const allSelected = groups.length > 0 && groups.every(g => selectedGroups.has(g.id));
            addCartBtn.classList.toggle('no-buy', !allSelected);
        };

        // Marca grupo como selecionado pelo usuário
        const markSelected = (group) => {
            if (!group || !group.id) return;
            selectedGroups.add(group.id);
            group.classList.remove('please-select');
            syncUI();
        };

        const container = document.querySelector('#js_buy_together_api_layout_1_groups');
        if (!container) return;

        // change = seleção em select, radio, checkbox
        container.addEventListener('change', (e) => {
            const target = e.target;
            if (!(target instanceof Element)) return;
            const group = target.closest(GROUP_SELECTOR);
            if (group) markSelected(group);
        }, { passive: true });

        // click em label/input = fallback para radios customizados
        container.addEventListener('click', (e) => {
            const target = e.target;
            if (!(target instanceof Element)) return;
            if (target.closest('label') || target.matches('input')) {
                const group = target.closest(GROUP_SELECTOR);
                if (group) setTimeout(() => markSelected(group), 0);
            }
        }, { passive: true });

        // Observa novos grupos sendo adicionados para colocar please-select
        const observer = new MutationObserver(() => syncUI());
        observer.observe(container, { childList: true, subtree: true });

        // Inicializa
        syncUI();
    });

    let listBuyTogether = document.getElementById('js_buy_together_api_layout_1_groups'),
        options = {
            childList: true
        }
    if (listBuyTogether) {
        observer = new MutationObserver(Callback);
        observer.observe(listBuyTogether, options);

        function Callback() {
            const products = document.querySelectorAll('#js_buy_together_api_layout_1_groups ul');
            if (products.length) {
                products.forEach(product => {
                    if (product.dataset.buyTogetherBound) return;
                    product.dataset.buyTogetherBound = '1';

                    const options = product.querySelector('.product-item__options');
                    if (options) {
                        options.addEventListener('click', () => {
                            const radioVariation = options.querySelector('.product-radio-variation');
                            if (radioVariation) {
                                radioVariation.classList.toggle('active');
                            }
                            product.classList.toggle('active');
                        });

                        if (window.matchMedia("(max-width: 991px)").matches) {
                            const detailList = product.querySelector('.product-item__content--container');
                            if (detailList) {
                                detailList.appendChild(options);
                            }
                        }
                    }
                });
            }
        }
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');
    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    const compreJunto = document.querySelector('#js_buy_together_api_layout_1');
    if (compreJunto) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_0' || node.querySelector('#js_buy_together_api_group_0')) {
                            const targetNode = node.id === 'js_buy_together_api_group_0' ? node : node.querySelector('#js_buy_together_api_group_0');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.info-product');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                        }
                    }
                });
            });
        });

        observer.observe(compreJunto, {
            childList: true,
            subtree: true
        });

    }

    if ($('.product-detail__header--photoArea-mobile, .mobile-slider')) {
        $('.product-detail__header--photoArea-mobile, .mobile-slider').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            infinite: false,
            mobileFirst: true,
            speed: 300,
            vertical: false,
            responsive: [
                {
                    breakpoint: 991,
                    settings: "unslick"
                },
            ]
        });
    }

    if ($('#product-detail-related-carrousel').length) {
        const prevArrow = $('.product-detail-related .group-text .arrows-content .arrows .prev');
        const nextArrow = $('.product-detail-related .group-text .arrows-content .arrows .next');

        $('#product-detail-related-carrousel').slick({
            swipeToSlide: true,
            touchThreshold: 100,
            arrows: true,
            prevArrow: prevArrow,
            nextArrow: nextArrow,
            dots: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                    }
                }
            ]
        });

        // Atualizar arrows ao redimensionar
        $(window).on('resize', function() {
            const wasResized = (window.innerWidth >= 1024) !== !isMobile;
            if (wasResized && $('#product-detail-related-carrousel').hasClass('slick-initialized')) {
                $('#product-detail-related-carrousel').slick('refresh');
            }
        });

        $('#product-detail-related-carrousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function(element) {
                    setTimeout(function(){
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                    }, 200);
                }
            });
        });
    }

    $('#photo-fancy').fancybox();

    if ($('.product-rating__review-list').length) {
        $('.product-rating__review-list').slick({
            arrows: false,
            dots: false,
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 300,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
    }
})